import { sepAPI } from '../API/sepAPI';
import { setSnackbarForEndpoint } from '../../utils/snackbar';
import {
  LogicAppSetting,
  LogicAppSettingUpdateBody,
} from '../../../shared/types/LogicAppSettings';

export const logicAppSettingsSlice = sepAPI.injectEndpoints({
  endpoints: (builder) => ({
    getLogicAppSettings: builder.query<LogicAppSetting[], void>({
      query: () => `logic-app-settings`,
      providesTags: ['LogicAppSettings'],
    }),

    updateLogicAppSetting: builder.mutation<
      LogicAppSetting,
      { id: number; body: LogicAppSettingUpdateBody }
    >({
      query: ({ id, body }) => ({
        url: `logic-app-settings/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['LogicAppSettings'],
      onQueryStarted: (_arg, api) => {
        setSnackbarForEndpoint(api, {
          successMessage: 'Logic App CC email has been updated.',
          errorMessage: 'There was a problem updating the Logic App CC email.',
        });
      },
    }),
  }),
});

export const {
  useGetLogicAppSettingsQuery,
  useUpdateLogicAppSettingMutation,
} = logicAppSettingsSlice;
